// export const ROOT_DATA_API  = process.env.REACT_APP_DATA_REST_API_ROOT || "http://localhost:8080";
export const ROOT_UMT_API = process.env.REACT_APP_UMT_REST_API_ROOT || "http://localhost:8081"

export const ROOT_DATA_API  = process.env.REACT_APP_DATA_REST_API_ROOT || "https://demo-solutions-api.to.lightcast.io";
// export const ROOT_UMT_API = process.env.REACT_APP_UMT_REST_API_ROOT || "https://demo-umt-api.to.lightcast.io"

export const ROOT_WEBAPP  = process.env.REACT_APP_WEBAPP_ROOT || "http://localhost:3000";
export const SOLUTION_NAME = process.env.REACT_APP_SOLUTION_NAME || "";
export const SOLUTION_ID = process.env.REACT_APP_SOLUTION_ID || 26;
export const I18N_ENABLED = process.env.REACT_APP_I18N_ENABLED || "true";
export const MAINTENANCE = process.env.REACT_APP_MAINTENANCE || false;
